import { Column } from "./DataTable";
import { Typography } from "@mui/material";
import { formatRelativeTime } from "../../utils/date";

export type DateColumn<T, S = string> = Omit<Column<T, S>, "tableCellBuilder"> & {
    getDate: (data: T) => string | Date | null;
    formatter?: (date: Date) => string;
}

export const useDateColumn = <T, S = string>(column: DateColumn<T, S>): Column<T, S> => {
    const parseDate = (date: string | Date): Date => {
        if (date instanceof Date) return date;
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
            throw new Error(`Invalid date: ${date}`);
        }
        return parsedDate;
    }

    return {
        ...column,
        tableCellBuilder: (data: T) => {
            const dateValue = column.getDate(data);
            if (!dateValue) return "";
            const date = parseDate(dateValue);
            const formattedDate = column.formatter ? column.formatter(date) : formatRelativeTime(date);
            return <Typography variant="subtitle2" whiteSpace="nowrap">
                {formattedDate}
            </Typography>;
        }
    }
}